import { createContext } from 'react';
import { RootStore } from './rootStore';

export type Store = RootStore;
export const store = new RootStore();
export const StoreContext = createContext<RootStore>(store);
